<template>
  <div class="ball-color-row">
    <div class="axis-label">{{ $t('betting.ballColor') }}</div>
    <div class="color-row">
      <button
        v-for="color in colorSlugs"
        :key="color"
        type="button"
        class="color-btn"
        :class="{ selected: modelValue === color }"
        :style="getColorButtonStyle(color, modelValue === color)"
        @click="selectColor(color)"
      >
        {{ BALL_COLOR_STYLES[color].label }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  BALL_COLOR_ORDER,
  BALL_COLOR_STYLES,
  type BallColorSlug,
} from '@/constants/sameColorBalls'

const props = defineProps<{
  modelValue: BallColorSlug | null
}>()

const emit = defineEmits<{
  'update:modelValue': [BallColorSlug | null]
}>()

const colorSlugs = BALL_COLOR_ORDER

function getColorButtonStyle(color: BallColorSlug, isSelected: boolean) {
  const style = BALL_COLOR_STYLES[color]
  if (isSelected) {
    return {
      backgroundColor: style.background,
      borderColor: style.border,
      color: style.text,
    }
  }

  return {
    backgroundColor: 'var(--bg-secondary, #fff)',
    borderColor: style.border,
    color: 'var(--text-primary)',
  }
}

function selectColor(color: BallColorSlug) {
  emit('update:modelValue', props.modelValue === color ? null : color)
}
</script>

<script lang="ts">
export default {
  name: 'BonusBallColorRow',
}
</script>

<style scoped>
.ball-color-row {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

.axis-label {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-primary);
}

.color-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.color-btn {
  flex: 1 1 calc(25% - 0.5rem);
  min-width: 4.5rem;
  padding: 0.55rem 0.35rem;
  border: 2px solid;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: all 0.15s ease;
}

.color-btn:hover {
  opacity: 0.9;
}

@media (min-width: 769px) {
  .color-row {
    flex-wrap: nowrap;
  }

  .color-btn {
    flex: 1;
    min-width: 0;
  }
}
</style>
